import React from 'react'

const useSlider = () => {
    const [value, setValue] = React.useState<number>()

    const handleChange = (value: number) => {
        console.log('handleChange value', value)
        setValue(value)
    }

    return {
        value: value,
        onChange: handleChange,
    }
}

export default useSlider
